import styled from "styled-components";

if (window.orientation == 0 || window.orientation == 180) {
    var size = window.innerWidth;
} else if (window.orientation == 90 || window.orientation == -90) {
    var size = window.innerWidth * .5;
}


export const SpecialStyle = styled.div`
    overflow:auto;

    box-sizing:content-box;
    padding:${(window.orientation == 90 || window.orientation == -90) && '0 25%' || '0'};
    width:${(window.orientation == 90 || window.orientation == -90) && '50%' || '100%'};
    height:100%;
    
    background-color:#F7F7F7;

    .full{
        position: relative;
        
        /* height:100%; */
        width:100%;

        background-color:#fff;

        .special{
            .am-navbar{ 
                position: fixed; 
                top:0; 
                z-index: 9;

                .am-navbar-title{ 
                    display: none;
                }
            }

            .bkspecial{ 
                background-size: contain;
            }

            .special-container{

                .banner{ 
                    position: relative;
                    height: 100%;
                    width: 100%;
                    
                    img{
                        width: 100%;
                        height:auto;
                    }

            }
            .intro-title{

                h4{   
                    font-size:${24 / 375 * size + 'px'}; 
                    color:#333; 
                    padding-left: ${16 / 375 * size + 'px'}; 
                    line-height: 1.5;
                }
            }

            .intro{
                padding: 0 ${16 / 375 * size + 'px'};
                margin-top: ${16 / 375 * size + 'px'};
                font-size: ${14 / 375 * size + 'px'}; 
                line-height: 1.5;
                color: #333;
            }

            .cate-container{

                .cate-item{
                    padding: 0 ${16 / 375 * size + 'px'};
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    .item{
                        display: flex;
                        width: 100%;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: flex-start; 
                        border-bottom: 1px solid transparent; 
                        padding-top: ${25.6 / 375 * size + 'px'}; 
                        padding-bottom: ${25.6 / 375 * size + 'px'};

                        .left{
                            width: ${124 / 375 * size + 'px'};
                            height: ${124 / 375 * size + 'px'};

                            border-radius: ${12 / 375 * size + 'px'};

                            img{
                                width: ${120 / 375 * size + 'px'};
                                height: ${120 / 375 * size + 'px'};
                                
                                border-radius: ${12 / 375 * size + 'px'};
                                box-shadow:0px 2px 8px 0px rgba(109,109,109,0.5);
                            }
                        }

                        .right{
                            width:100%;
                            margin-left:  ${20 / 375 * size + 'px'}; 
                            display: flex; 
                            position: relative;

                            height:  ${120 / 375 * size + 'px'};
                            flex-direction: column;
                            align-items: flex-start;

                            .title{
                                overflow:hidden;
                                text-overflow:ellipsis;
                                white-space:nowrap;

                                max-width:${203 / 375 * size + 'px'};

                                font-size:  ${18 / 375 * size + 'px'};
                                color: #333;

                                font-weight: bold;

                                line-height: 1.5;
                            }

                            .explain{
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 3;
                                overflow: hidden;
                                
                                max-width:${203 / 375 * size + 'px'};

                                font-size:${14.08 / 375 * size + 'px'};
                                color: #999;

                                line-height: 1.5;
                                opacity:0.8;
                            }

                            .playbtn{
                                font-size:${14.08 / 375 * size + 'px'};  
                                padding:  ${6.4 / 375 * size + 'px'}  ${16 / 375 * size + 'px'};  
                                background: #28B6FF; 
                                border-radius:  ${50 / 375 * size + 'px'}; 
                                color: #333; 
                                display: inline-block;
                                display: flex; 
                                align-items: center; 
                                color: #fff;
                                box-shadow:0  ${.96 / 375 * size + 'px'}  ${4 / 375 * size + 'px'} 0 rgba(47,47,47,0.23); 
                                position: absolute; 
                                bottom: 0; 
                                left: 0;

                                img{
                                    width: ${16.96 / 375 * size + 'px'}; 
                                    height: ${16.96 / 375 * size + 'px'}; 
                                    margin-right: ${4.8 / 375 * size + 'px'};
                                }
                            }
                        }
                    }

                    .item-bottom-border{
                        height:1px;
                        opacity: .3;
                        width:100%;
                    }
                }
                
            }

            .ad-banner{
                width: 100%;
                height: 100%;
                margin-top:  ${24 / 375 * size + 'px'};
                box-shadow: 0  ${2 / 375 * size + 'px'}  ${10 / 375 * size + 'px'} 0 rgba(0,0,0,0.10);
                border-radius:  ${6 / 375 * size + 'px'};

                img{
                    width:100%;
                    height:auto;
                }
            }

            .story-container{

                .story-item{
                    padding: 0  ${16 / 375 * size + 'px'};
                    /* margin-top: ${24 / 375 * size + 'px'}; */
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;

                    .item{
                        display: flex;  
                        width: 100%;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: flex-start;
                        /* margin-bottom:  ${16 / 375 * size + 'px'};  */
                        padding-top:  ${25.6 / 375 * size + 'px'}; 
                        padding-bottom:  ${25.6 / 375 * size + 'px'};
                        align-items: flex-start;
                        border-bottom: 1px solid transparent;

                        .left{
                            width:  ${124 / 375 * size + 'px'};
                            height:  ${124 / 375 * size + 'px'};
                            border-radius:  ${12 / 375 * size + 'px'};

                            img{
                                width:  ${120 / 375 * size + 'px'};
                                height:  ${120 / 375 * size + 'px'};
                                border-radius:  ${12 / 375 * size + 'px'};
                                box-shadow:0px 2px 8px 0px rgba(109,109,109,0.5);
                            }
                        }

                        .right{
                            width:100%;
                            margin-left:  ${20 / 375 * size + 'px'}; 
                            display: flex; 
                            position: relative;

                            height: ${120 / 375 * size + 'px'};
                            flex-direction: column;
                            align-items: flex-start;

                            .title{
                                overflow:hidden;
                                text-overflow:ellipsis;
                                white-space:nowrap;

                                max-width:${203 / 375 * size + 'px'};

                                font-size: ${18 / 375 * size + 'px'};
                                color: #333;

                                font-weight: bold;

                                line-height: 1.5;
                            }

                            .explain{
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 3;
                                overflow: hidden;

                                max-width:${203 / 375 * size + 'px'};

                                font-size: ${14.08 / 375 * size + 'px'};
                                color: #999;

                                line-height: 1.5;
                                opacity:0.8;
                            }

                            .playbtn{

                                font-size: ${14.08 / 375 * size + 'px'};  
                                padding: ${6.4 / 375 * size + 'px'} ${16 / 375 * size + 'px'};  
                                background: #28B6FF; 
                                border-radius: ${50 / 375 * size + 'px'}; 
                                color: #333; 
                                display: inline-block;
                                display: flex; 
                                align-items: center; 
                                color: #fff;
                                box-shadow:0 ${.96 / 375 * size + 'px'}  ${4 / 375 * size + 'px'} 0 rgba(47,47,47,0.23); 
                                position: absolute; 
                                bottom: 0; 
                                left: 0;

                                img{
                                    width: ${16.96 / 375 * size + 'px'}; 
                                    height: ${16.96 / 375 * size + 'px'}; 
                                    margin-right: ${4.8 / 375 * size + 'px'};
                                }
                            }
                        }

                        .play{
                            width: ${25.6 / 375 * size + 'px'};
                            height: ${25.6 / 375 * size + 'px'};
                            margin-top: ${8 / 375 * size + 'px'};

                            img{
                                width: 100%;
                                height: 100%;;
                            }
                        }
                    }

                    .item-bottom-border{
                        height:1px;
                        opacity: .3;
                        width:100%;
                    }
                }
            }

            .past-past{

                .title{
                    font-size: ${20 / 375 * size + 'px'};
                    color: #373737;
                    font-weight: bold;
                }

                .button1{
                    background: #A8C6FF;
                    box-shadow: 0 ${2 / 375 * size + 'px'} ${10 / 375 * size + 'px'} 0 rgba(0,0,0,0.10);
                    border-radius: ${6 / 375 * size + 'px'};
                    font-size: ${20 / 375 * size + 'px'};
                    color: #FFFFFF;
                }

                .button2{
                    background: #BCBCBC;
                    box-shadow: 0 ${2 / 375 * size + 'px'} ${10 / 375 * size + 'px'} 0 rgba(0,0,0,0.10);
                    border-radius: ${6 / 375 * size + 'px'};
                    font-size: ${20 / 375 * size + 'px'};
                    color: #FFFFFF;
                }

                .button3{
                    background: #FFE59A;
                    box-shadow: 0 ${2 / 375 * size + 'px'} ${10 / 375 * size + 'px'} 0 rgba(0,0,0,0.10);
                    border-radius: ${6 / 375 * size + 'px'};
                    font-size: ${20 / 375 * size + 'px'};
                    color: #FFFFFF;
                }
            }
        }
    }
}

`;